import { useNavigate, useParams } from "react-router-dom";
import { OrderSuccess } from "@/components/pages";
import { useCallback } from "react";


const OrderSuccessView = () => {
    const { order } = useParams<'order'>();
    const navigate = useNavigate();

    const handleReturnToOrder = useCallback(() => {
        navigate(`/order-view/order=${order}`);
    }, [order, navigate]);

    return (
        <OrderSuccess onReturnToOrder={handleReturnToOrder}></OrderSuccess>
    );
}

export default OrderSuccessView;